import { render } from "./CalendarEventForm.vue?vue&type=template&id=1e349d78"
import script from "./CalendarEventForm.vue?vue&type=script&lang=js"
export * from "./CalendarEventForm.vue?vue&type=script&lang=js"
script.render = render

export default script